export default "__VITE_ASSET___dm9uX1x__"